import { render, staticRenderFns } from "./TimelineBase.vue?vue&type=template&id=5e42a248"
var script = {}
import style0 from "./TimelineBase.vue?vue&type=style&index=0&id=5e42a248&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports